const translations = {
    part: 'Part',
    partIsRequired: 'Part is required'
};

export default translations;
